export default __webpack_public_path__ + "static/media/hexbetGenericMob.63335566.png";